<div class="guide-section">
  <div class="row">
    <div class="guide-section__title">
      Delivery promise
      @if (showExpansionGuide === 'deliveryPromise' || exp3.expanded == true) {
        <div class="guide-section__subtext">
          Tell your customers when to expect their delivery to arrive during checkout
        </div>
      }
    </div>
    <div class="delivery-promise-container">
      <mat-accordion>
        <mat-expansion-panel
          (opened)="onOpenExpansion('deliveryPromise')"
          (closed)="onCloseExpansion()"
          [expanded]="isExpandedNeeded('deliveryPromise')"
          #exp3="matExpansionPanel">
          <!-- this is the header -->
          <mat-expansion-panel-header>
            <mat-panel-description>
              <div class="content__delivery-promise__title" [ngClass]="exp3.expanded == true ? 'margin-title-exp' : ''">
                {{
                  shippingMethodCategory === ShippingMethod.DOMESTIC_LIVE_RATE ||
                  shippingMethodCategory === ShippingMethod.FIXED_LIVE_RATE ||
                  shippingMethodCategory === ShippingMethod.INTERNATIONAL_FIXED_LIVE_RATE ||
                  shippingMethodCategory === ShippingMethod.STORE_PICK_UP
                    ? 'Processing time'
                    : 'Delivery promise'
                }}
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="formGroup">
            <div class="flex-col">
              @if (shippingMethodCategory !== ShippingMethod.STORE_PICK_UP) {
                <div>
                  <pdq-radio-group
                    formControlName="estimatedTimeConversions"
                    (onChange)="onEstimateTimeRateConversionChange($event)">
                    @for (estimatedTime of estimatedTimeLiveRateConversionOptions; track estimatedTime) {
                      <pdq-radio-button
                        [value]="estimatedTime.value"
                        [disabled]="checkEstimatedTimeDisabled(estimatedTime.value)"
                        [checked]="formGroup.value['estimatedTimeConversions'] === estimatedTime.value"
                        [text]="estimatedTime.text"
                        [labelIcon]="estimatedTime.labelIcon"
                        [tooltip]="
                          checkEstimatedTimeDisabled(estimatedTime.value)
                            ? 'Contact PDQ Support to activate MAXX Promise'
                            : ''
                        "
                        [subText]="estimatedTime.subText">
                      </pdq-radio-button>
                    }
                  </pdq-radio-group>
                </div>

                @if (formGroup?.get('estimatedTimeConversions')?.value === 'linked_calendar') {
                  <div>
                    <pdq-dropdown
                      width="260"
                      title="Select linked calendar"
                      [options]="linkedDatePickerExtensionOptions"
                      [defaultOption]="
                        getLinkedDatePickerExtensionDefaultValue(formGroup.value['linkedDatePickerExtensionId'])
                      "
                      formControlName="linkedDatePickerExtensionId"
                      placeholder="Pick one">
                    </pdq-dropdown>
                  </div>
                }
              }

              @if (showMultiShipDatePickerProfile) {
                <div class="multi-ship-date-picker-profile">
                  <pdq-checkbox
                    labelSize="small"
                    label="Link multi ship date picker profile"
                    [checked]="linkMultiShipDatePickerProfile"
                    (onChange)="onToggleMultiShipDatePickerProfileLink($event)">
                  </pdq-checkbox>
                  @if (linkMultiShipDatePickerProfile) {
                    <div class="multi-ship-date-picker-profile__dropdown">
                      <pdq-dropdown
                        width="260"
                        [options]="multiShipDatePickerProfileOptions"
                        [defaultOption]="
                          getMultiShipDatePickerProfileDefaultValue(formGroup.value['linkedMultiShipDatePickerProfile'])
                        "
                        (onChange)="onMultiShipDatePickerProfilePick($event)"
                        placeholder="Pick one">
                      </pdq-dropdown>
                    </div>
                  }
                  @if (linkMultiShipDatePickerProfile && !isDontShowTabActive) {
                    <pdq-checkbox
                      labelSize="small"
                      label="Show the delivery promise only after the customer picks a delivery date"
                      [checked]="showPromiseOnlyWhenDateSelected"
                      (onChange)="onTogglePromiseOnlyWhenDateSelected($event)">
                    </pdq-checkbox>
                  }
                </div>
              }

              <div class="delivery-display-format">
                <div class="delivery-display-format__label">
                  Delivery display format
                  <pdq-icon
                    icon="more_information"
                    [color]="runningABTest ? 'var(--warning-default)' : ''"
                    [matTooltip]="deliveryDisplayFormatTooltip"
                    matTooltipClass="pdq-mat-tooltip"></pdq-icon>
                </div>
                <pdq-tabs-group
                  variant="toggle"
                  leftMargin="none"
                  [selectFirstDefault]="false"
                  (onChange)="onDeliveryDisplayFormatChange($event)">
                  <pdq-tab
                    value="dont_show"
                    label="Don't show"
                    [active]="isDontShowTabActive"
                    [disabled]="!!runningABTest">
                  </pdq-tab>
                  @if (categoriesSupportEtaBusinessDays.includes(shippingMethodCategory)) {
                    <pdq-tab
                      value="delivery_time"
                      label="Delivery time"
                      [active]="isDeliveryTimeTabActive"
                      [disabled]="!!runningABTest"
                      [tooltipText]="
                        !!runningABTest
                          ? 'Disabled due running A/B test'
                          : 'Uses Shopify\'s default calendar to calculate business days and may cause issues outside of US.' +
                            getAdditionalDeliveryPromiseText()
                      ">
                    </pdq-tab>
                  }
                  <pdq-tab
                    [value]="'date_range'"
                    [label]="shippingMethodCategory === 'local' ? 'Time range' : 'Date range'"
                    [active]="isDateRangeTabActive"
                    [disabled]="!!runningABTest"
                    [tooltipText]="
                      !!runningABTest ? 'Disabled due running A/B test' : getAdditionalDeliveryPromiseText()
                    ">
                  </pdq-tab>
                </pdq-tabs-group>
                @if (isDeliveryTimeTabActive) {
                  <span class="toggle-subtext">("Between 2-5 business days")</span>
                }
                @if (isDateRangeTabActive) {
                  <span class="toggle-subtext">{{
                    shippingMethodCategory === 'local'
                      ? '("Estimated delivery today between 3pm-5pm")'
                      : '("Estimated delivery between Tuesday Aug 14 to Thursday Aug 16, 2021")'
                  }}</span>
                }
              </div>

              @if (
                formGroup?.get('estimatedTimeConversions')?.value === 'pdqiq' &&
                !!(formGroup?.value)['displayEstDelivery']
              ) {
                <pdq-input
                  formControlName="deliveryPromiseArrivalSingleDateDisplayText"
                  label="Display text for single arrival date"
                  [disabled]="!!runningABTest"
                  [tooltip]="!!runningABTest ? 'Disabled due running A/B test' : ''"
                  tooltipIconColor="var(--warning-default)"
                  [invalid]="formGroup?.controls?.deliveryPromiseArrivalSingleDateDisplayText?.hasError('dp_date_text')"
                  [invalidMsg]="
                    formGroup?.controls?.deliveryPromiseArrivalSingleDateDisplayText?.getError('dp_date_text')
                  "
                  [direction]="shop?.metadata?.locale === 'he' ? 'rtl' : 'ltr'"></pdq-input>
                <pdq-input
                  formControlName="deliveryPromiseArrivalDateRangeDisplayText"
                  label="Display text for date range"
                  [disabled]="!!runningABTest"
                  [tooltip]="!!runningABTest ? 'Disabled due running A/B test' : ''"
                  tooltipIconColor="var(--warning-default)"
                  [invalid]="formGroup?.controls?.deliveryPromiseArrivalDateRangeDisplayText?.hasError('dp_date_text')"
                  [invalidMsg]="
                    formGroup?.controls?.deliveryPromiseArrivalDateRangeDisplayText?.getError('dp_date_text')
                  "
                  [direction]="shop?.metadata?.locale === 'he' ? 'rtl' : 'ltr'"></pdq-input>
              }

              @if (
                (!!(formGroup?.value)['displayEstDelivery'] ||
                  !!(formGroup?.value)['displayEstimatedDeliveryBusinessDays']) &&
                formGroup?.get('estimatedTimeConversions')?.value === 'pdqiq'
              ) {
                <div class="flex-row">
                  <pdq-dropdown
                    class="subject"
                    variant="static"
                    width="260"
                    style="margin-right: 12px"
                    title="Base MAXX Promise on this shipping data"
                    tooltip="MAXX Promise will use historical data from this method to make its delivery promise"
                    [options]="deliveryPromisePdqIqBaseShippingMethodOptions"
                    formControlName="deliveryPromisePdqIqBaseShippingMethod"
                    (onChange)="onDeliveryPromisePDQIQBaseShippingMethodSelect($event)"
                    [defaultOption]="
                      getPdqIqBaseMethodDefaultOption(formGroup.value['deliveryPromisePdqIqBaseShippingMethod'])
                    "
                    placeholder="Please select"
                    [invalid]="formGroup.errors?.pdqiq_shipping_method_missmatch"
                    invalidMsg="This is a required field">
                  </pdq-dropdown>
                  <pdq-dropdown
                    class="subject"
                    variant="static"
                    width="175"
                    style="margin-right: 12px"
                    title="Percentile"
                    tooltip=" The higher the percentage number, the safer the delivery promise.
                      For example, 25th percentile will display your most aggressive delivery promise."
                    [options]="deliveryPromisePdqIqPercentileOptions"
                    formControlName="deliveryPromisePdqIqPercentile"
                    placeholder="Please select"
                    [invalid]="formGroup.errors?.pdqiq_percentile_missmatch"
                    invalidMsg="This is a required field">
                  </pdq-dropdown>
                </div>
                <div class="maxx-ai-toggle">
                  <pdq-checkbox
                    formControlName="maxxAiDeliveryPromiseEnabled"
                    [checked]="formGroup?.value['maxxAiDeliveryPromiseEnabled']">
                  </pdq-checkbox>
                  <div class="maxx-ai-toggle-content">
                    <span class="maxx-ai-toggle-label">
                      ✨ Allow MAXX to show <strong>faster delivery promises</strong> when our AI model predicts quicker
                      delivery. Your percentile setting acts as the fallback—customers never see a slower promise.
                    </span>
                    @if (formGroup?.value['maxxAiDeliveryPromiseEnabled']) {
                      <div>
                        <div class="maxx-ai-min-promise">
                          <pdq-input-arrows
                            formControlName="maxxAiDeliveryPromiseMinCap"
                            label="Minimum promise"
                            tooltip="Optional. The fastest promise MAXX will ever show, regardless of AI prediction. Leave empty for no cap."
                            placeholder="——"
                            [required]="false"
                            [min]="0"
                            widthSize="auto"
                            width="135">
                          </pdq-input-arrows>
                          <span class="maxx-ai-min-promise-days">days</span>
                        </div>
                        <span class="maxx-ai-hint">Optional. Fastest promise MAXX will ever show.</span>
                      </div>
                    }
                  </div>
                </div>
                @if (
                  deliveryPromisePdqIqBaseShippingMethodZonesInitiallyLoaded &&
                  selectedDeliveryPromisePdqIqBaseShippingMethodZones?.length == 0
                ) {
                  <div class="zone-info">
                    <skeleton-zones [numOfCards]="8"></skeleton-zones>
                  </div>
                }
                @if (selectedDeliveryPromisePdqIqBaseShippingMethodZones?.length > 0) {
                  <div class="zone-section">
                    <span class="zone-label">Promise by zone:</span>
                    <div class="zone-info">
                      @for (zone of selectedDeliveryPromisePdqIqBaseShippingMethodZones; track zone) {
                        <div class="zone-box">
                          <div class="zone-name">Zone {{ zone.zone }}</div>
                          <div class="zone-time">
                            {{ zone | pdqiqZoneDeliveryPromiseDays: formGroup.value['deliveryPromisePdqIqPercentile'] }}
                            days
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              }

              @if (!!(formGroup?.value)['displayEstDelivery']) {
                @if (formGroup?.get('estimatedTimeConversions')?.value !== 'pdqiq') {
                  <pdq-input
                    formControlName="deliveryPromiseArrivalSingleDateDisplayText"
                    label="Display text for single arrival date"
                    [disabled]="!!runningABTest"
                    [tooltip]="!!runningABTest ? 'Disabled due running A/B test' : ''"
                    tooltipIconColor="var(--warning-default)"
                    [invalid]="
                      formGroup?.controls?.deliveryPromiseArrivalSingleDateDisplayText?.hasError('dp_date_text')
                    "
                    [invalidMsg]="
                      formGroup?.controls?.deliveryPromiseArrivalSingleDateDisplayText?.getError('dp_date_text')
                    "
                    [direction]="shop?.metadata?.locale === 'he' ? 'rtl' : 'ltr'"></pdq-input>
                  <pdq-input
                    formControlName="deliveryPromiseArrivalDateRangeDisplayText"
                    label="Display text for date range"
                    [disabled]="!!runningABTest"
                    [tooltip]="!!runningABTest ? 'Disabled due running A/B test' : ''"
                    tooltipIconColor="var(--warning-default)"
                    [invalid]="
                      formGroup?.controls?.deliveryPromiseArrivalDateRangeDisplayText?.hasError('dp_date_text')
                    "
                    [invalidMsg]="
                      formGroup?.controls?.deliveryPromiseArrivalDateRangeDisplayText?.getError('dp_date_text')
                    "
                    [direction]="shop?.metadata?.locale === 'he' ? 'rtl' : 'ltr'"></pdq-input>
                }
              }

              <delivery-promise-restrictions [formGroup]="formGroup"></delivery-promise-restrictions>
              <pdq-divider variant="dashed"></pdq-divider>

              @if (formGroup?.get('estimatedTimeConversions')?.value !== 'linked_calendar') {
                <delivery-promise-deliverytime-settings
                  [formGroup]="formGroup"
                  [runningABTest]="!!runningABTest"
                  [shippingMethodCategory]="shippingMethodCategory"
                  [estimatedTimeConversions]="
                    formGroup.value['estimatedTimeConversions']
                  "></delivery-promise-deliverytime-settings>
              }

              <div>
                <div style="margin: 0 0 5px 0">Exclude non-business days</div>

                <div class="row">
                  <div class="custom-select-panel recommended-delivery-courier-select-width">
                    <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                    <mat-select
                      placeholder="Pick one"
                      #holidayWeekendDateSelect
                      panelClass="pdq-mat-select--panel"
                      class="pdq-mat-select pdq-mat-select--default"
                      [disableOptionCentering]="true"
                      (selectionChange)="onDeliveryPromiseSelect($event)"
                      [(ngModel)]="deliveryPromiseTypeSelect"
                      formControlName="deliveryPromiseTypeSelect">
                      @for (settings of deliveryPromiseSettings; track settings) {
                        <mat-option [value]="settings"> {{ settings.type }}</mat-option>
                      }
                    </mat-select>
                  </div>

                  <div class="spaceLeft">
                    @if (deliveryPromiseTypeSelect?.type !== 'Custom Date') {
                      <div class="custom-select-panel recommended-delivery-courier-select-width">
                        <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                        <mat-select
                          [ngClass]="!noPickYet ? 'disable-select-style' : ''"
                          [disabled]="!noPickYet"
                          [placeholder]="dynamicPlaceholder"
                          #countryDatesSelect
                          panelClass="pdq-mat-select--panel"
                          class="pdq-mat-select pdq-mat-select--default"
                          [disableOptionCentering]="true"
                          formControlName="deliveryPromiseValue"
                          [(ngModel)]="deliveryPromiseValue">
                          @for (calendarList of googleCalendarIdsList; track calendarList) {
                            <mat-option [value]="calendarList">
                              @if (deliveryPromiseTypeSelect?.type !== 'Blackout date range') {
                                <span>{{ calendarList.name }}</span>
                              }
                              @if (deliveryPromiseTypeSelect?.type === 'Blackout date range') {
                                <span>
                                  {{ calendarList['startDate'] | date }} -
                                  {{ calendarList['endDate'] | date }}
                                </span>
                              }
                            </mat-option>
                          }
                        </mat-select>
                      </div>
                    }
                    @if (deliveryPromiseTypeSelect?.type === 'Custom Date') {
                      <div class="custom-select-panel recommended-delivery-courier-select-width">
                        <div class="datepicker-container">
                          <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                          <app-custom-datepicker
                            [startDate]="deliveryPromiseValue?.startDate"
                            [endDate]="deliveryPromiseValue?.endDate"
                            [minDate]="currentDate"
                            (changeDateRange)="handleCustomDateRangeChange($event)"
                            variant="form"></app-custom-datepicker>
                        </div>
                      </div>
                    }
                  </div>
                  <pdq-button variant="primary" label="Add" (click)="addDeliveryPromise()"></pdq-button>
                </div>
                @if (showDeliveryPromiseErrorMsg) {
                  <div style="font-size: 13px; color: red">
                    {{ showDeliveryPromiseErrorMsg }}
                  </div>
                }
                <div class="custom-divier"></div>
                @for (
                  deliveryPromiseDontCalculateOn of formGroup.get('deliveryPromiseDontCalculateOn')['value'];
                  track deliveryPromiseDontCalculateOn;
                  let i = $index
                ) {
                  <div formArrayName="deliveryPromiseDontCalculateOn">
                    <div class="row spaceTop">
                      <div class="content__custom-blackout-dates__box" style="width: 260px">
                        {{ convertDeliveryPromiseType(deliveryPromiseDontCalculateOn['type']) }}
                      </div>
                      <div class="content__custom-blackout-dates__box" style="margin-left: 20px; width: 260px">
                        {{
                          deliveryPromiseDontCalculateOn?.value?.startDate ||
                          deliveryPromiseDontCalculateOn?.value?.endDate
                            ? (deliveryPromiseDontCalculateOn?.value?.startDate | date) +
                              ' - ' +
                              (deliveryPromiseDontCalculateOn?.value?.endDate | date)
                            : convertDeliveryPromiseValue(
                                deliveryPromiseDontCalculateOn['value'],
                                deliveryPromiseDontCalculateOn['type']
                              )
                        }}
                      </div>
                      <pdq-button
                        (onClick)="removeDeliveryPromise(i)"
                        iconColor="var(--on-surface-light)"
                        variant="ghost"
                        icon="close"></pdq-button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
